import Equipment from "@/app/settings/overview/Equipment"
import Members from "@/app/settings/overview/Members"
import TeamInfo from "@/app/settings/overview/TeamInfo"

import "./settingOverview.scss"
import OpenAPIDialog from "@/app/settings/overview/OpenAPIDialog"
import { useState } from "react"

export default function SettingOverview() {
  const [dialogOpened, setDialogOpened] = useState(false)
  return (
    <div className="SettingOverviewCont">
      <TeamInfo onClickOpenAPI={() => setDialogOpened(true)} />
      <div className="SettingOverviewBottomCont">
        <Members />
        <Equipment />
      </div>
      <OpenAPIDialog open={dialogOpened} onClose={() => setDialogOpened(false)} />
    </div>
  )
}
